import React from 'react';
import { QBox } from '@qualio/ui-components';
import { TemplateDetail } from '../../types';
import ContentViewer from '../ContentViewer/ContentViewer';
import { prepareContent } from '../../utils/contentUtils';
import styles from '../SectionedContentEditor/SectionedContentEditor.module.css';

export const TemplateDetailsBody: React.FC<{ data: TemplateDetail }> = ({ data }) => {
  return (
    <QBox width="100%" aria-label="template-body" className={`${styles['template-body']}`}>
      <ContentViewer content={prepareContent(data)} isSectionedContent={data.sectioned_content} />
    </QBox>
  );
};
